import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const PerformanceChart = ({ data, title }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-elevation-2">
          <p className="text-sm font-medium text-foreground mb-2">{payload?.[0]?.payload?.name}</p>
          <div className="space-y-1">
            <p className="text-xs text-muted-foreground">
              Score: <span className="font-semibold text-primary data-text">{payload?.[0]?.value}%</span>
            </p>
            <p className="text-xs text-muted-foreground">
              Questions: <span className="font-semibold text-foreground data-text">{payload?.[0]?.payload?.questions}</span>
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 shadow-elevation-2 border border-border">
      <h3 className="text-lg md:text-xl font-semibold text-foreground mb-4 md:mb-6">{title}</h3>
      <div className="w-full h-64 md:h-80" aria-label={`${title} Bar Chart`}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 10, left: -20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="name" 
              tick={{ fill: 'var(--color-muted-foreground)', fontSize: 12 }}
              tickLine={{ stroke: 'var(--color-border)' }}
            />
            <YAxis 
              tick={{ fill: 'var(--color-muted-foreground)', fontSize: 12 }}
              tickLine={{ stroke: 'var(--color-border)' }}
              domain={[0, 100]}
            />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: 'var(--color-muted)' }} />
            <Legend 
              wrapperStyle={{ fontSize: '12px', color: 'var(--color-muted-foreground)' }}
            />
            <Bar 
              dataKey="score" 
              fill="var(--color-primary)" 
              radius={[8, 8, 0, 0]}
              name="Average Score (%)"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PerformanceChart;